//LOCAWEB
export const baseUrl = 'https://reguaapi.agape-sistemas.com';
export const portalUrl = "https://needhelpapi.agape-sistemas.com";
// export const frontUrl = 'https://reguafront.agape-sistemas.com';

//UNIMED
//  export const baseUrl = 'http://192.168.0.20:8082';
//  export const frontUrl = 'http://192.168.0.20';
//  export const portalUrl = 'http://192.168.0.20:8083';

//LOCAL AGAPE
// export const baseUrl = 'http://192.168.1.2:8082';
// export const frontUrl = 'http://192.168.1.2';

// LOCALHOST
    // export const baseUrl = "https://localhost:7082";
//  export const portalUrl = "https://localhost:7092";
// 